export default {
  namespaced: true,

  state: {
    list: null,
    recommendations: null
  },

  mutations: {
    list(state, list) {
      state.list = list;
    },

    recommendations(state, list) {
      state.recommendations = list;
    }
  },

  actions: {
    loadAll({ dispatch, commit }) {
      return new Promise((resolve) => {
        dispatch("ajax", {
          url: "/v1/saved-searches"
        }, { root: true }).then((list) => {
          resolve();
          commit("list", list);
        });
      });
    },

    save({ dispatch }, inquiry) {
      return new Promise((resolve) => {
          dispatch("ajax", {
            method: "put",
            url: "/v1/saved-searches/" + inquiry.uuid,
            data: inquiry
          }, { root: true }).then(() => {
            resolve();
          });
      });
    },

    delete({ dispatch }, id) {
      return new Promise((resolve) => {
          dispatch("ajax", {
            method: "delete",
            url: "/v1/saved-searches/" + id
          }, { root: true }).then(() => {
            resolve();
          });
      });
    },

    loadRecommendations({ dispatch, commit }) {
      return new Promise((resolve) => {
        dispatch("ajax", {
          method: "post",
          url: "/v1/saved-searches/recommendations"
        }, { root: true }).then((list) => {
          commit("recommendations", list);
          resolve();
        });
      });
    },

    sendRecommendatationsEmail({ dispatch }) {
      return new Promise((resolve) => {
        dispatch("ajax", {
          method: "post",
          url: "/v1/saved-searches/recommendations-email"
        }, { root: true }).then(() => {
          resolve();
        });
      });
    }
  }
};
